import useIsMobile from 'common/hooks/useIsMobile';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';
import { Button, Form } from 'react-bootstrap';

interface Props {
    message?: string | null;
    messageLine2?: string | null;
    isVisible: boolean;
    onYes: (e: React.MouseEvent<HTMLButtonElement>) => void;
    onNo: (e: React.MouseEvent<HTMLButtonElement>) => void;
    children?: React.ReactElement;
    isInformation?: boolean | null;
}

const QuestionYesNo: React.FC<Props> = ({ message, messageLine2, isVisible, onYes, onNo, children, isInformation }: Props) => {
    const { t } = useTranslation();
    const isMobile = useIsMobile();

    const contentStyle: React.CSSProperties = {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? '90%' : '420px',
        maxWidth: '90%',
        backgroundClip: 'padding-box',
        backgroundColor: '#FFFFFF',
        border: '1px solid #E2E8F0',
        borderRadius: '0.75rem',
        boxShadow: '0 16px 48px rgba(11, 17, 33, 0.16)',
        outline: '0 none',
        padding: '1.5rem',
    };
    const overlayStyle: React.CSSProperties = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        backgroundColor: 'rgba(11, 17, 33, 0.4)',
        zIndex: 1001,
        backdropFilter: 'blur(2px)',
    };
    const customStyles = {
        content: contentStyle,
        overlay: overlayStyle,
    };

    return (
        <Modal
            isOpen={isVisible}
            style={customStyles}
        >
            <div>
                <div className="mb-4">
                    <Form.Label className="text-base font-semibold text-slate-900">
                        {!isInformation ? t('common.question') : t('common.information')}
                    </Form.Label>
                </div>
                {message && (
                    <div className="mb-5">
                        <p className="text-sm text-slate-600 leading-relaxed m-0">{message}</p>
                        {messageLine2 && <p className="text-sm text-slate-600 leading-relaxed mt-1 m-0">{messageLine2}</p>}
                    </div>
                )}
                {children}
                <div className="flex justify-end gap-2.5 mt-4 pt-4 border-t border-slate-100">
                    <Button onClick={onNo} variant='secondary' size="sm">
                        {isInformation ? t('common.ok') : t('common.no')}
                    </Button>
                    {!isInformation && (
                        <Button onClick={onYes} variant='primary' size="sm">
                            {t('common.yes')}
                        </Button>
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default QuestionYesNo;
